import { render, staticRenderFns } from "./AdvertisementDialog.vue?vue&type=template&id=191c4d60"
import script from "./AdvertisementDialog.vue?vue&type=script&lang=js"
export * from "./AdvertisementDialog.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementDialog.vue?vue&type=style&index=0&id=191c4d60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports